import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import { DateTime } from 'luxon'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { withException = '' } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    withException: withException == 'true',
    max_arrival_date: DateTime.now().plus({ days: 90 }).toFormat('dd/MM/yyyy')
  }
}

export default async function () {
  try {
    await initForm()
  } catch (error) {
    console.error('useGccVisaPreload error: ', error)
  }
}
